import TablesSecret from "./TablesSecretApp";
import { TaskType } from "./Components/types/types";
// Руководство:
//
// В `tasks` добавляются задания, разделённые на уровни с раундами.
// Ссылки на уровни создаются автоматически по значению `id`.
//
// `type` — тип игры:
// 1 — таблица со слогами;
// 2 — поиск слов в таблице;
// 3 — расшифровка слов.
//
// `id` — идентификатор уровня. Используется в адресной строке.
//
// `rounds` — массив раундов. (Кроме типа 1, words - является массивом раундов)
//
// Тип 1:
// --`size` — размер таблицы: [количество строк, количество столбцов]. На всю игру
// --`words` — слова, разделённые на слоги символом `|`. ОДНО СЛОВО-ОДИН РАУНД
//   Например: ["КО|ЖУ|РА", "МА|ШИ|НА"].
//
// Тип 2:
// --`size` — размер таблицы: [количество строк, количество столбцов]. На каждый раунд отдельно
// --`text` — слова, которые необходимо найти в таблице.
//   Несколько слов разделяются пробелом.
//
// Тип 3:
// --Каждый элемент `rounds` — отдельный раунд. На каждый раунд отдельно
// --В каждом раунде указываются слова, которые необходимо расшифровать.
//   Например: [["КИПР", "КАПА"], ["ДОМ", "ПАРТА"]]
//
// Регистр букв не имеет значения.
//
// Имеется тест для проверки валидности всех заданий, заданных в `tasks`.

export const tasks: TaskType[] = [
  //первый тип игры
  {
    type: 1,
    id: "1",
    rounds: [
      {
        size: [5, 3],
        words: ["КО|ЖУ|РА","РУ|КА"],
      },
    ],
  },

  // Второй тип игры
  {
    type: 2,
    id: "1",
    rounds: [
      {
        size: [4,8],
        text: "СТРЕКОЗА",
      },
       {
        size: [7,7],
        text: "КЛАВИАТУРА",
      },
    ],
  },

  // Третий тип игры
  {
    type: 3,
    id: "1",

    rounds: [
      ["кипр", "капа", "ЮРТА"],
      ["ДОМ", "САЛАЗКА", "ПАРТА"],
      ["СОСНА", "ДУБ"],
    ],
  },
];

// Дополнительные параметры в адресной строке:
// первый параметр - тип игры (type)
// второй параметр - айди игры со своим набором раундов (id)
// /r    — случайный порядок раундов.
// /medium - усложнение символов для 2 типа игры
//
// Примеры:
// /TablesSecret/1/1
// /TablesSecret/1/1/r
// /TablesSecret/2/1/r/medium

const tablesSecretRoutes = tasks.flatMap((task) => [
  {
    path: `/TablesSecret/${task.type}/${task.id}/`,
    element: (
      <TablesSecret
        random={false}
        rounds={task.rounds}
        type={task.type}
        difficulty="easy"
      />
    ),
  },
  {
    path: `/TablesSecret/${task.type}/${task.id}/r`,
    element: (
      <TablesSecret
        random={true}
        rounds={task.rounds}
        type={task.type}
        difficulty="easy"
      />
    ),
  },
  {
    path: `/TablesSecret/${task.type}/${task.id}/medium`,
    element: (
      <TablesSecret
        random={false}
        rounds={task.rounds}
        type={task.type}
        difficulty="medium"
      />
    ),
  },
  {
    path: `/TablesSecret/${task.type}/${task.id}/r/medium`,
    element: (
      <TablesSecret
        random={true}
        rounds={task.rounds}
        type={task.type}
        difficulty="medium"
      />
    ),
  },
  {
    path: `/TablesSecret/${task.type}/${task.id}/medium/r`,
    element: (
      <TablesSecret
        random={true}
        rounds={task.rounds}
        type={task.type}
        difficulty="medium"
      />
    ),
  },
]);

export default tablesSecretRoutes;
